import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

const Privacy = (props) => {
  const style = {
    backgroundImage: "url(" + props.data.image_url + ")",
  };
  return (
    <div>
      <div className="flex flex-col pt-8 md:pt-16">
        <div
          id="privacy"
          style={style}
          className="md:mx-5 md:rounded-3xl h-[20rem] sm:h-[18rem] md:h-[30rem] bg-cover"
        >
          <div
            id="privacyGradiant"
            className="flex items-end md:rounded-3xl pl-10 pb-0 md:pb-10 pt-0 pr-0  h-full"
          ></div>
        </div>
        <div className="px-4 md:px-20 py-4 md:py-10 flex flex-col">
          <div className="md:pb-4">
            <Link
              to="/"
              className="w-11 pb-4 flex flex-row items-center text-gray-700 hover:text-black"
            >
              <img
                width="22"
                height="22"
                src="https://img.icons8.com/windows/32/back.png"
                alt=""
              />
              <p className="font-bold text-xs md:text-lg">Back</p>
            </Link>
            <hr></hr>
          </div>
          <div className="flex flex-col pb-6">
            <h2 className="text-2xl md:text-4xl text-yellow-950 py-6">
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.title),
                }}
              />
            </h2>
            {props.data.content_sections.map((i) => (
              <div>
                {i?.section_text?.split("\n").map((j) => (
                  <div>
                    <br></br>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(j),
                      }}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer data={props.footer} />
    </div>
  );
};

export default Privacy;
